module.exports = __webpack_public_path__ + "static/media/thumbnail.32f6ec4f.jpg";